import React from "react";
import { ParticipantFilesContext } from "../context/participantFilesContext";
import { IFile } from "../interface/iFile";
import { IUploads } from "../interface/iUploads";
import RenderHeadline from "./renderHeadline";
import UploadTile from "./uploadTile";
import { Box } from "@mui/material";

const CoachUploads = (): React.JSX.Element => {
  const {
    uploads,
  }: {
    uploads: IUploads;
  } = React.useContext(ParticipantFilesContext);

  return (
    <Box sx={{ mt: 4 }}>
      <RenderHeadline text={"Von Deinem Coach hochgeladene Unterlagen"} />

      {uploads.files.uploadCoach.map((file: IFile) => (
        <UploadTile key={file.id} file={file} deletable={false} />
      ))}
    </Box>
  );
};

export default CoachUploads;
